export const TYPES = {
  UPDATE_AUTHENTICATED_USER: 'UPDATE_AUTHENTICATED_USER',
  AUTH_SIGN_IN_DONE: 'AUTH_SIGN_IN_DONE',
  AUTH_SIGN_IN_ERROR: 'AUTH_SIGN_IN_ERROR',
  AUTH_SIGN_OUT: 'AUTH_SIGN_OUT',
  AUTH_FORGOT_PASSWORD_DONE: 'AUTH_FORGOT_PASSWORD_DONE',
  AUTH_FORGOT_PASSWORD_ERROR: 'AUTH_FORGOT_PASSWORD_ERROR',
  AUTH_RESET_PASSWORD_DONE: 'AUTH_RESET_PASSWORD_DONE',
  AUTH_RESET_PASSWORD_ERROR: 'AUTH_RESET_PASSWORD_ERROR',
  FETCH_ASSET_BY_ID_DONE: 'FETCH_ASSET_BY_ID_DONE',
  FETCH_ASSET_DOCUMENTS_DONE: 'FETCH_ASSET_DOCUMENTS_DONE',
  FETCH_ASSET_NOTES_DONE: 'FETCH_ASSET_NOTES_DONE',
  FETCH_AUTHENTICATED_USER_DONE: 'FETCH_AUTHENTICATED_USER_DONE',
  FETCH_CONTACT_BY_ID_DONE: 'FETCH_CONTACT_BY_ID_DONE',
  FETCH_CONTACT_NOTES_DONE: 'FETCH_CONTACT_NOTES_DONE',
  FETCH_CONTACT_SERVICE_REQUESTS_DONE: 'FETCH_CONTACT_SERVICE_REQUESTS_DONE',
  FETCH_CONTACTS_DOCUMENTS_DONE: 'FETCH_CONTACTS_DOCUMENTS_DONE',
  FETCH_CONTACTS_DONE: 'FETCH_CONTACTS_DONE',
  FETCH_ITEM_DOCUMENTS_DONE: 'FETCH_ITEM_DOCUMENTS_DONE',
  FETCH_FAQS_NOTES_DOCUMENTS_DONE: 'FETCH_FAQ_NOTES_DOCUMENTS_DONE',
  FETCH_ITEM_NOTES_DONE: 'FETCH_ITEM_NOTES_DONE',
  FETCH_ITEMS_DONE: 'FETCH_ITEMS_DONE',
  FETCH_PROPERTIES_DONE: 'FETCH_PROPERTIES_DONE',
  FETCH_PROPERTY_BY_ID_DONE: 'FETCH_PROPERTY_BY_ID_DONE',
  FETCH_PROPERTY_DOCUMENTS_DONE: 'FETCH_PROPERTY_DOCUMENTS_DONE',
  FETCH_PROPERTY_NOTES_DONE: 'FETCH_PROPERTY_NOTES_DONE',
  FETCH_PROPERTY_SERVICE_REQUESTS_DONE: 'FETCH_PROPERTY_SERVICE_REQUESTS_DONE',
  FETCH_PROPERTY_SUITES_DONE: 'FETCH_PROPERTY_SUITES_DONE',
  FETCH_USER_SUITES: 'FETCH_USER_SUITES',
  SET_USER_SUITE: 'SET_USER_SUITE',
  FETCH_SERVICE_REQUEST_BY_ID_DONE: 'FETCH_SERVICE_REQUEST_BY_ID_DONE',
  UPDATE_SERVICE_REQUEST_DONE: 'UPDATE_SERVICE_REQUEST_DONE',
  UPDATE_WARRANTY_ISSUE_STATUS_AND_LOADING:
    'UPDATE_WARRANTY_ISSUE_STATUS_AND_LOADING',
  FETCH_SERVICE_REQUEST_DOCUMENTS_DONE: 'FETCH_SERVICE_REQUEST_DOCUMENTS_DONE',
  FETCH_SERVICE_REQUEST_NOTES_DONE: 'FETCH_SERVICE_REQUEST_NOTES_DONE',
  CLEAR_SERVICE_REQUEST: 'CLEAR_SERVICE_REQUEST',
  FETCH_SERVICE_REQUESTS_DONE: 'FETCH_SERVICE_REQUESTS_DONE',
  FETCH_SERVICE_REQUESTS_SEARCH_DONE: 'FETCH_SERVICE_REQUESTS_SEARCH_DONE',
  FETCH_SUITE_ASSETS_DONE: 'FETCH_SUITE_ASSETS_DONE',
  FETCH_SUITE_BY_ID_DONE: 'FETCH_SUITE_BY_ID_DONE',
  FETCH_SUITE_DOCUMENTS_DONE: 'FETCH_SUITE_DOCUMENTS_DONE',
  FETCH_SUITE_NOTES_DONE: 'FETCH_SUITE_NOTES_DONE',
  FETCH_SUITE_SERVICE_REQUESTS_DONE: 'FETCH_SUITE_SERVICE_REQUESTS_DONE',
  FETCH_TYPEAHEAD_RESULTS_DONE: 'FETCH_TYPEAHEAD_RESULTS_DONE',
  FETCH_TYPEAHEAD_RESULTS: 'FETCH_TYPEAHEAD_RESULTS',
  SAVE_ASSET_DONE: 'SAVE_ASSET_DONE',
  SAVE_CONTACT_DONE: 'SAVE_CONTACT_DONE',
  DELETE_CONTACT_DONE: 'DELETE_CONTACT_DONE',
  ROLES_FETCHED: 'ROLES_FETCHED',
  CHANGE_PASSWORD_DONE: 'CHANGE_PASSWORD_DONE',
  DELETE_UNIT_DONE: 'DELETE_UNIT_DONE',
  UPDATE_SUITE_DONE: 'UPDATE_SUITE_DONE',
  DELETE_ITEM_DONE: 'DELETE_ITEM_DONE',
  UPDATE_ITEM_DONE: 'UPDATE_ITEM_DONE',
  SAVE_ASSETS_DONE: 'SAVE_ASSETS_DONE',
  ADD_ASSET_DONE: 'ADD_ASSET_DONE',
  UPDATE_ASSET_DONE: 'UPDATE_ASSET_DONE',
  DELETE_ASSET_DONE: 'DELETE_ASSET_DONE',
  SAVE_CONTACT_NOTE_DONE: 'SAVE_CONTACT_NOTE_DONE',
  SAVE_FAQ_NOTES_DOCUMENTS_DONE: 'SAVE_FAQ_NOTES_DOCUMENTS_DONE',
  UPDATE_FAQ_NOTES_DOCUMENTS_DONE: '_FAQ_NOTES_DOCUMENTS_DONE',
  DELETE_FAQ_NOTES_DOCUMENTS_DONE: 'DELETE_FAQ_NOTES_DOCUMENTS_DONE',
  CLEAR_FAQ_NOTES_DOCUMENTS: 'CLEAR_FAQ_NOTES_DOCUMENTS',
  SAVE_ITEM_DONE: 'SAVE_ITEM_DONE',
  SAVE_SUITE_DONE: 'SAVE_SUITE_DONE',
  SAVE_FAQ_DONE: 'SAVE_FAQ_DONE',
  SET_CONTACT_FORM_DATA: 'SET_CONTACT_FORM_DATA',
  SET_ITEM_FORM_DATA: 'SET_ITEM_FORM_DATA',
  CLEAR_ITEM_FORM_DATA: 'CLEAR_ITEM_FORM_DATA',
  SET_PROPERTY_FORM_DATA: 'SET_PROPERTY_FORM_DATA',
  CLEAR_PROPERTY_FORM_DATA: 'CLEAR_PROPERTY_FORM_DATA',
  SET_ACTIVE_TAB: 'SET_ACTIVE_TAB',
  CLEAR_ACTIVE_TAB: 'CLEAR_ACTIVE_TAB',
  SET_ACTIVE_SUITE_TAB: 'SET_ACTIVE_SUITE_TAB',
  CLEAR_ACTIVE_SUITE_TAB: 'CLEAR_ACTIVE_SUITE_TAB',
  SET_ACTIVE_COMMONAREA_TAB: 'SET_ACTIVE_COMMONAREA_TAB',
  CLEAR_ACTIVE_COMMONAREA_TAB: 'CLEAR_ACTIVE_COMMONAREA_TAB',
  SET_ACTIVE_CONTACT_TAB: 'SET_ACTIVE_CONTACT_TAB',
  CLEAR_ACTIVE_CONTACT_TAB: 'CLEAR_ACTIVE_CONTACT_TAB',
  SET_ACTIVE_CATALOG_TAB: 'SET_ACTIVE_CATALOG_TAB',
  CLEAR_ACTIVE_CATALOG_TAB: 'CLEAR_ACTIVE_CATALOG_TAB',
  SET_TAB_LIST: 'SET_TAB_LIST',
  SET_ALLOWED_TAB_LIST: 'SET_ALLOWED_TAB_LIST',
  SET_SELECTED_MODULE_PERMISSION: 'SET_SELECTED_MODULE_PERMISSION',
  CLEAR_TAB_LIST: 'CLEAR_TAB_LIST',
  CLEAR_ALLOWED_TAB_LIST: 'CLEAR_ALLOWED_TAB_LIST',
  CLEAR_SELECTED_MODULE_PERMISSION: 'CLEAR_SELECTED_MODULE_PERMISSION',
  SAVE_SERVICE_REQUEST_DONE: 'SAVE_SERVICE_REQUEST_DONE',
  SAVE_SERVICE_REQUEST_BY_GROUP: 'SAVE_SERVICE_REQUEST_BY_GROUP',
  SET_CURRENT_GROUP_SERVICE_REQUEST_INDEX:
    'SET_CURRENT_GROUP_SERVICE_REQUEST_INDEX',
  SET_DISPLAY_CLOSE_AND_RESOLVED_TICKETS:
    'SET_DISPLAY_CLOSE_AND_RESOLVED_TICKETS',
  CLEAR_SAVE_SERVICE_REQUEST_BY_GROUP: 'CLEAR_SAVE_SERVICE_REQUEST_BY_GROUP',
  DELETE_SERVICE_REQUEST_DONE: 'DELETE_SERVICE_REQUEST_DONE',
  SET_EMAIL_TEMPLATES: 'SET_EMAIL_TEMPLATES',
  SET_EMAIL_TEMPLATE_FORM: 'SET_EMAIL_TEMPLATE_FORM',
  CLEAR_EMAIL_TEMPLATE_FORM: 'CLEAR_EMAIL_TEMPLATE_FORM',
  CLEAR_EMAIL_TEMPLATES: 'CLEAR_EMAIL_TEMPLATE_FORM',
  SAVE_STATUS_DONE: 'SAVE_STATUS_DONE',
  FETCH_ALL_ITEM_TYPES_DONE: 'FETCH_ALL_ITEM_TYPES_DONE',
  GET_ALL_USER_TYPE_ROLES: 'GET_ALL_USER_TYPE_ROLES',
  CLEAR_CONTACT_FORM_DATA: 'CLEAR_CONTACT_FORM_DATA',
  UPDATE_CONTACT_DONE: 'UPDATE_CONTACT_DONE',
  SET_FND_FORM_DATA: 'SET_FND_FORM_DATA',
  CLEAR_FND_FORM_DATA: 'CLEAR_FND_FORM_DATA',
  SET_ASSET_FORM_DATA: 'SET_ASSET_FORM_DATA',
  CLEAR_ASSET_FORM_DATA: 'CLEAR_ASSET_FORM_DATA',
  SET_SEARCH: 'SET_SEARCH',
  CLEAR_SEARCH: 'CLEAR_SEARCH',
  FETCH_MESSAGES_DONE: 'FETCH_MESSAGES_DONE',
  POST_MESSAGE_DONE: 'POST_MESSAGE_DONE',
  USER_PROFILE_DETAILS_FETCHED: 'USER_PROFILE_DETAILS_FETCHED',
  SET_SETTINGS_FORM_DATA: 'SET_SETTINGS_FORM_DATA',
  UPDATE_COMPANY_DETAILS_DONE: 'UPDATE_COMPANY_DETAILS_DONE',
  UPDATE_NOTIFICATION_DETAILS_DONE: 'UPDATE_NOTIFICATION_DETAILS_DONE',
  CLEAR_SUITES: 'CLEAR_SUITES',
  CLEAR_ASSETS: 'CLEAR_ASSETS',
  CLEAR_MESSAGES: 'CLEAR_MESSAGES',
  CLEAR_SERVICE_REQUESTS_DONE: 'CLEAR_SERVICE_REQUESTS_DONE',
  FETCH_MAINTENANCE_GUIDE_FOR_ASSET_BY_ITEM_ID_DONE:
    'FETCH_MAINTENANCE_GUIDE_FOR_ASSET_BY_ITEM_ID_DONE',
  FETCH_FAQS_FOR_ASSET_BY_ITEM_ID_DONE: 'FETCH_FAQS_FOR_ASSET_BY_ITEM_ID_DONE',

  FETCH_SUITE_AREAS_DONE: 'FETCH_SUITE_AREAS_DONE',
  FETCH_SUITE_ASSET_AREAS_DONE: 'FETCH_SUITE_ASSET_AREAS_DONE',

  SET_PROPERTY_WALK_THROUGH_FORM_IS_VISIBLE:
    'SET_PROPERTY_WALK_THROUGH_FORM_IS_VISIBLE',
  SET_PROPERTY_WALK_THROUGH_FORM_DATA: 'SET_PROPERTY_WALK_THROUGH_FORM_DATA',
  SET_PROPERTY_WALK_THROUGH_FORM_NEXT_STEP:
    'SET_PROPERTY_WALK_THROUGH_FORM_NEXT_STEP',
  SET_PROPERTY_WALK_THROUGH_FORM_PREVIOUS_STEP:
    'SET_PROPERTY_WALK_THROUGH_FORM_PREVIOUS_STEP',
  SET_PROPERTY_WALK_THROUGH_FROM_STEP: 'SET_PROPERTY_WALK_THROUGH_FROM_STEP',
  EXIT_PROPERTY_WALK_THROUGH_FORM: 'EXIT_PROPERTY_WALK_THROUGH_FORM',
  FETCH_AREAS_AND_SUB_AREAS: 'FETCH_AREAS_AND_SUB_AREAS',
  CHANGE_SEQUENCE_AREAS_AND_SUBAREAS: 'CHANGE_SEQUENCE_AREAS_AND_SUBAREAS',

  SET_EASY_WALK_THROUGH_FORM_NEXT_STEP: 'SET_EASY_WALK_THROUGH_FORM_NEXT_STEP',
  SET_EASY_WALK_THROUGH_FROM_STEP: 'SET_EASY_WALK_THROUGH_FROM_STEP',
  SET_EASY_WALK_THROUGH_FORM_DATA: 'SET_EASY_WALK_THROUGH_FORM_DATA',
  SET_EASY_WALK_THROUGH_FORM_PREVIOUS_STEP:
    'SET_EASY_WALK_THROUGH_FORM_PREVIOUS_STEP',
  EXIT_EASY_WALK_THROUGH_FORM: 'EXIT_EASY_WALK_THROUGH_FORM',

  GET_WALK_THROUGH_SUITES: 'GET_WALK_THROUGH_SUITES',
  SET_OFFLINE_WALKTHROUGH_SAVE_ACTIONS: 'SET_OFFLINE_WALKTHROUGH_SAVE_ACTIONS',
  CLEAR_OFFLINE_WALKTHROUGH_SAVE_ACTIONS:
    'CLEAR_OFFLINE_WALKTHROUGH_SAVE_ACTIONS',

  SET_LOADER_LOADING: 'SET_LOADER_LOADING',
  STOP_LOADER_LOADING: 'STOP_LOADER_LOADING',
  SET_PRLOADER_LOADING: 'SET_PRLOADER_LOADING',
  STOP_PRLOADER_LOADING: 'STOP_PRLOADER_LOADING',
  SET_FORMLOADER_LOADING: 'SET_FORMLOADER_LOADING',
  STOP_FORMLOADER_LOADING: 'STOP_FORMLOADER_LOADING',

  SET_VALIDATION: 'SET_VALIDATION',
  CLEAR_VALIDATION: 'CLEAR_VALIDATION',
  PROPERTY_MANAGER_DETAILS_DONE: 'PROPERTY_MANAGER_DETAILS_DONE',
  PROPERTY_MANAGER_CALENDLY_DONE: 'PROPERTY_MANAGER_CALENDLY_DONE',
  FETCH_RECENT_ACTIVITY_DONE: 'FETCH_RECENT_ACTIVITY_DONE',

  CLEAR_GLOBAL_SEARCH: 'CLEAR_GLOBAL_SEARCH',

  SET_ANNOUNCEMENT_FORM_DATA: 'SET_ANNOUNCEMENT_FORM_DATA',
  CLEAR_ANNOUNCEMENT_FORM_DATA: 'CLEAR_ANNOUNCEMENT_FORM_DATA',
  FETCH_ANNOUNCEMENTS_DONE: 'FETCH_ANNOUNCEMENTS_DONE',
  SAVE_ANNOUNCEMENTS_DONE: 'SAVE_ANNOUNCEMENTS_DONE',
  DELETE_ANNOUNCEMENTS_DONE: 'DELETE_ANNOUNCEMENTS_DONE',
  CLEAR_ANNOUNCEMENTS_DONE: 'CLEAR_ANNOUNCEMENTS_DONE',
  FETCH_COMMON_AREAS_DONE: 'FETCH_COMMON_AREAS_DONE',
  FETCH_PROPERTY_COMMON_AREAS_DONE: 'FETCH_PROPERTY_COMMON_AREAS_DONE',
  FETCH_PROPERTY_COMMON_AREAS_FOR_FILTER_DONE:
    'FETCH_PROPERTY_COMMON_AREAS_FOR_FILTER_DONE',
  SELECTION_OF_PROPERTY_COMMON_AREAS_FOR_FILTER_DONE:
    'SELECTION_OF_PROPERTY_COMMON_AREAS_FOR_FILTER_DONE',
  CLEAR_PROPERTY_COMMON_AREAS_FOR_FILTER_DONE:
    'CLEAR_PROPERTY_COMMON_AREAS_FOR_FILTER_DONE',
  CLEAR_SELECTED_PROPERTY_COMMON_AREAS_FOR_FILTER_DONE:
    'CLEAR_SELECTED_PROPERTY_COMMON_AREAS_FOR_FILTER_DONE',

  FETCH_WALK_THROUGHS_DONE: 'FETCH_WALK_THROUGHS_DONE',

  FETCH_SUITE_USERS_LIST: 'FETCH_SUITE_USERS_LIST',
  SAVE_SUITE_CONTACT_DONE: 'SAVE_SUITE_CONTACT_DONE',
  UPDATE_SUITE_CONTACT_DONE: 'UPDATE_SUITE_CONTACT_DONE',
  CLEAR_SUITE_USERS: 'CLEAR_SUITE_USERS',
  SUITE_UPDATE_SYNC_STATUS_DONE: 'SUITE_UPDATE_SYNC_STATUS_DONE',

  FETCH_OVER_VIEW_STATUS_DAYS_DONE: 'FETCH_OVER_VIEW_STATUS_DAYS_DONE',

  FETCH_COMMON_ISSUES_DONE: 'FETCH_COMMON_ISSUES_DONE',
  SAVE_COMMON_ISSUE_DONE: 'SAVE_COMMON_ISSUE_DONE',
  UPDATE_COMMON_ISSUE_DONE: 'UPDATE_COMMON_ISSUE_DONE',
  DELETE_COMMON_ISSUE_DONE: 'DELETE_COMMON_ISSUE_DONE',
  CLEAR_COMMON_ISSUE_DONE: 'CLEAR_COMMON_ISSUE_DONE',

  FETCH_COMMON_AREA_ASSETS_DONE: 'FETCH_COMMON_AREA_ASSETS_DONE',
  SET_COMMON_AREA_ASSET_FORM_DATA: 'SET_COMMON_AREA_ASSET_FORM_DATA',
  CLEAR_COMMON_AREA_ASSET_FORM_DATA: 'CLEAR_COMMON_AREA_ASSET_FORM_DATA',

  SAVE_COMMON_AREA_DONE: 'SAVE_COMMON_AREA_DONE',
  UPDATE_COMMON_AREA_DONE: 'UPDATE_COMMON_AREA_DONE',
  DELETE_COMMON_AREA_DONE: 'DELETE_COMMON_AREA_DONE',
  FETCH_PROPERTY_DEVELOPERS_DONE: 'FETCH_PROPERTY_DEVELOPERS_DONE',
  UPDATE_PROPERTY_DEVELOPERS_DONE: 'UPDATE_PROPERTY_DEVELOPERS_DONE',
  DELETE_PROPERTY_DEVELOPERS_DONE: 'DELETE_PROPERTY_DEVELOPERS_DONE',

  SERVICE_REQUEST_PAGINATION: 'SERVICE_REQUEST_PAGINATION',
  SERVICE_REQUEST_PAGE_COUNT: 'SERVICE_REQUEST_PAGE_COUNT',
  CLEAR_PAGE_COUNT: 'CLEAR_PAGE_COUNT',
  CLEAR_PAGINATION_COUNT: 'CLEAR_PAGINATION_COUNT',

  FETCH_COUNTS_DONE: 'FETCH_COUNTS_DONE',
  CLEAR_COUNTS_DONE: 'CLEAR_COUNTS_DONE',
  UPDATE_SERVICE_REQUEST_STATUS_DONE: 'UPDATE_SERVICE_REQUEST_STATUS_DONE',
  ADD_FILTER_QUERY: 'ADD_FILTER_QUERY',
  CLEAR_FILTER_REQUEST: 'CLEAR_FILTER_REQUEST',
  ADD_SUITE_ONBOARDING_CONVEYANCE_FORM_LIST_BY_PROPERTY_CSV:
    'ADD_SUITE_ONBOARDING_CONVEYANCE_FORM_LIST_BY_PROPERTY_CSV',
  CLEAR_SUITE_ONBOARDING_CONVEYANCE_FORM_LIST_BY_PROPERTY_CSV:
    'CLEAR_SUITE_ONBOARDING_CONVEYANCE_FORM_LIST_BY_PROPERTY_CSV',

  ARCHIVE_SERVICE_REQUESTS_DONE: 'ARCHIVE_SERVICE_REQUESTS_DONE',
  FETCH_REPORTS_DONE: 'FETCH_REPORTS_DONE',
  CLEAR_REPORTS_DONE: 'CLEAR_REPORTS_DONE',

  FETCH_SERVICE_REQUEST_ACTIVITY_BY_ID_DONE:
    'FETCH_SERVICE_REQUEST_ACTIVITY_BY_ID_DONE',
  FETCHED_SUITE_USERS_ADD_TO_CONTACTS_DONE:
    'FETCHED_SUITE_USERS_ADD_TO_CONTACTS_DONE',

  START_LOADING_DOWNLOAD_SERVICE_REQUEST_LIST_CSV:
    'START_LOADING_DOWNLOAD_SERVICE_REQUEST_LIST_CSV',
  STOP_LOADING_DOWNLOAD_SERVICE_REQUEST_LIST_CSV:
    'STOP_LOADING_DOWNLOAD_SERVICE_REQUEST_LIST_CSV',
  CLEAR_LOADING_DOWNLOAD_SERVICE_REQUEST_LIST_CSV:
    'CLEAR_LOADING_DOWNLOAD_SERVICE_REQUEST_LIST_CSV',
  FETCHED_DOWNLOAD_SERVICE_REQUEST_LIST_CSV_DONE:
    'FETCHED_DOWNLOAD_SERVICE_REQUEST_LIST_CSV_DONE',
  SET_MAIN_SERVICE_REQUEST_PDF_DOWNLOAD_LIST:
    'SET_MAIN_SERVICE_REQUEST_PDF_DOWNLOAD_LIST',
  SET_SIDE_BAR: 'SET_SIDE_BAR',

  FETCH_VIDEOS_DONE: 'FETCH_VIDEOS_DONE',
  FETCH_MAINTAINANCE_GUIDE_BY_SUITE_ID: 'FETCH_MAINTAINANCE_GUIDE_BY_SUITE_ID',
  GET_PROPERTY_BUILDINGS_DONE: 'GET_PROPERTY_BUILDINGS_DONE',
  GET_BUILDING_LEVELS_DONE: 'GET_BUILDING_LEVELS_DONE',
  HOMEOWNER_ONBOARDING_FORM_DATA: 'HOMEOWNER_ONBOARDING_FORM_DATA',
  CLEAR_HOMEOWNER_ONBOARDING_FORM_DATA: 'CLEAR_HOMEOWNER_ONBOARDING_FORM_DATA',
  HOMEOWNER_ONBOARDING_DATA: 'HOMEOWNER_ONBOARDING_DATA',
  FETCH_HOMEOWNER_ONBOARDING_DATA: 'FETCH_HOMEOWNER_ONBOARDING_DATA',
  CLEAR_HOMEOWNER_ONBOARDING_DATA: 'CLEAR_HOMEOWNER_ONBOARDING_DATA',
  GET_SUITE_STATUSES_DONE: 'GET_SUITE_STATUSES_DONE',
  FETCH_PROPERTY_STAGES: 'FETCH_PROPERTY_STAGES',
  FETCH_PROPERTY_STATUSES: 'FETCH_PROPERTY_STATUSES',
  SORTING_FAQS_HOMEOWNER_ONBOARDING_DATA:
    'SORTING_FAQS_HOMEOWNER_ONBOARDING_DATA',
  FETCH_CONSTRUCTION_STAGES_DONE: 'FETCH_CONSTRUCTION_STAGES_DONE',
  CLEAR_CONSTRUCTION_STAGES_DONE: 'CLEAR_CONSTRUCTION_STAGES_DONE',
  FETCH_MORE_DETAILS_DONE: 'FETCH_MORE_DETAILS_DONE',
  CLEAR_MORE_DETAILS_DONE: 'CLEAR_MORE_DETAILS_DONE',
  IS_FETCH_MORE_DETAILS_LOADING: 'IS_FETCH_MORE_DETAILS_LOADING',
  CLOSE_FETCH_MORE_DETAILS_LOADING: 'CLOSE_FETCH_MORE_DETAILS_LOADING',
  FETCH_ONBOARDING_ORDERS: 'FETCH_ONBOARDING_ORDERS',
  SAVE_ONBOARDING_ORDER_ID: 'SAVE_ONBOARDING_ORDER_ID',
  FETCH_ONBOARDING_ORDER_DETAILS: 'FETCH_ONBOARDING_ORDER_DETAILS',
  CLEAR_FETCH_ONBOARDING_ORDER_DETAILS: 'CLEAR_FETCH_ONBOARDING_ORDER_DETAILS',
  FETCH_ONBOARDING_ORDER_DETAILS_LOADING:
    'FETCH_ONBOARDING_ORDER_DETAILS_LOADING',
  SET_ONBOARDING_ORDER_CHECKLISTDETAILS:
    'SET_ONBOARDING_ORDER_CHECKLISTDETAILS',
  SET_ONBOARDING_ORDER_CHECKLIST_DOCUMENTS:
    'SET_ONBOARDING_ORDER_CHECKLIST_DOCUMENTS',
  SET_ONBOARDING_ORDER_CHECKLIST_NOTES: 'SET_ONBOARDING_ORDER_CHECKLIST_NOTES',
  CLEAR_FETCH_ONBOARDING_ORDERS: 'CLEAR_FETCH_ONBOARDING_ORDERS',
  CLEAR_PROPERTY_MANAGER_DETAILS: 'CLEAR_PROPERTY_MANAGER_DETAILS',
  FETCH_ORDERS_LOADING: 'FETCH_ORDERS_LOADING',
  DELETE_ONBOARDING_ORDER_CHECKLIST_DOCUMENTS:
    'DELETE_ONBOARDING_ORDER_CHECKLIST_DOCUMENTS',
  FETCH_CONVEYANCE_FORM: 'FETCH_CONVEYANCE_FORM',
  CLEAR_CONVEYANCE_FORM: 'CLEAR_CONVEYANCE_FORM',
  FETCH_CONVEYANCE_FORM_DATA: 'FETCH_CONVEYANCE_FORM_DATA',
  CLEAR_FETCH_CONVEYANCE_FORM_DATA: 'CLEAR_FETCH_CONVEYANCE_FORM_DATA',

  DELETE_HOMEOWNER_ONBOARDING_ORDER_DATA:
    'DELETE_HOMEOWNER_ONBOARDING_ORDER_DATA',
  FETCH_PROPERTIES_CATALOG_DONE: 'FETCH_PROPERTIES_CATALOG_DONE',
  CLEAR_PROPERTIES_CATALOG_DONE: 'CLEAR_PROPERTIES_CATALOG_DONE',
  SET_WALKTHROUGH_REVIEW_STATUS: 'SET_WALKTHROUGH_REVIEW_STATUS',
  CLEAR_KEY_CONTACTS_DONE: 'CLEAR_KEY_CONTACTS_DONE',
  FETCH_KEY_CONTACTS_DONE: 'FETCH_KEY_CONTACTS_DONE',
  SAVE_WALKTHROUGH: 'SAVE_WALKTHROUGH',
  DELETE_WALKTHROUGH_DONE: 'DELETE_WALKTHROUGH_DONE',
  CLEAR_WALKTHROUGH_DONE: 'CLEAR_WALKTHROUGH_DONE',
  SAVE_SUITE_RESPONSE_DONE: 'SAVE_SUITE_RESPONSE_DONE',
  SAVE_ITEMS_RESPONSE_DONE: 'SAVE_ITEMS_RESPONSE_DONE',
  CLEAR_RESPONSE_DONE: 'CLEAR_RESPONSE_DONE',
  CLEAR_SUITE_ASSET_AREAS_DONE: 'CLEAR_SUITE_ASSET_AREAS_DONE',
  UPDATE_MESSAGE_TO_INREAD_TO_READ: 'UPDATE_MESSAGE_TO_INREAD_TO_READ',
  FETCH_SUITE_FAQS_DONE: 'FETCH_SUITE_FAQS_DONE',
  SPECIFICATION_SAVE_DONE: 'SPECIFICATION_SAVE_DONE',
  SPECIFICATION_UPDATE_DONE: 'SPECIFICATION_UPDATE_DONE',
  FETCH_SPECIFICATIONS_DONE: 'FETCH_SPECIFICATIONS_DONE',
  SPECIFICATION_DELETE_DONE: 'SPECIFICATION_DELETE_DONE',
  CLEAR_SPECIFICATIONS_DONE: 'CLEAR_SPECIFICATIONS_DONE',
  FETCH_KEY_PICKUP_SERVICE_REQUESTS_DONE:
    'FETCH_KEY_PICKUP_SERVICE_REQUESTS_DONE',
  FETCH_KEY_PICKUP_IMPORTANT_DOCUMENTS_DONE:
    'FETCH_KEY_PICKUP_IMPORTANT_DOCUMENTS_DONE',
  CLEAR_KEY_PICKUP_DONE: 'CLEAR_KEY_PICKUP_DONE',
  KEY_PICKUP_LOADING_DONE: 'KEY_PICKUP_LOADING_DONE',
  SET_BUILD_VERSION: 'SET_BUILD_VERSION',
  FETCH_SERVICE_REQUEST_STATS_DONE: 'FETCH_SERVICE_REQUEST_STATS_DONE',
  CLEAR_SERVICE_REQUEST_STATS_DONE: 'CLEAR_SERVICE_REQUEST_STATS_DONE',
  FETCH_CUSTOMER_FEEDBACK_DONE: 'FETCH_CUSTOMER_FEEDBACK_DONE',
  FETCH_NOTES: 'FETCH_NOTES',
  CLEAR_NOTES: 'CLEAR_NOTES',
};

export const PATHS = {
  ASSETS_VIEW: '/app/assets/:id',
  AUTH_FORGOT_PASSWORD: '/auth/forgot-password',
  AUTH_RESET_PASSWORD: '/auth/reset-password',
  AUTH_ACTIVATE: '/auth/activate',
  AUTH_SIGN_IN: '/auth/sign-in',
  AUTH_SIGN_OUT: '/auth/sign-out',
  CONTACTS_LIST: '/app/contacts',
  CONTACTS_VIEW: '/app/contacts/:id',
  ITEMS_LIST: '/app/catalog',
  PROPERTIES_LIST: '/app/properties',
  PROPERTIES_VIEW: '/app/properties/:id',
  SERVICE_REQUESTS_LIST: '/app/service-requests',
  SERVICE_REQUESTS_VIEW: '/app/service-requests/:id',
  SETTINGS: '/app/settings',
  SUITES_VIEW: '/app/suites/:id',
  KEY_PICKUP_VIEW: '/app/key-pickup/:id',
  ITEMS_VIEW: '/app/items/:id',
  ACTIVATE: '/auth/activate',
  VIDEO_CHAT: '/app/videoChat',
  VIEW_IMAGE: '/app/viewImage',
  DASHBOARD: '/app/dashboard',
  EVENT_ADDING: '/app/addevent',
  ANNOUNCEMENTS: '/app/announcements',
  ANNOUNCEMENTS_VIEW: '/app/announcement/:id',
  COMMON_AREA_VIEW: '/app/commonareas/:id',
  REPORTING: '/app/reporting',
  KEY_CONTACTS_LIST: '/app/keycontacts',
  KEY_CONTACTS_VIEW: '/app/keycontacts/:id',
  HOMEOWNER_ONBOARDING: '/app/homeowneronboarding',
  HOMEOWNER_ONBOARDING_DASHBOARD: '/app/homeowneronboardingdashboard',
  INBOX: '/app/inbox',
  REQUEST: '/app/request',
  EMAIL_TEMPLATES: '/app/emailtemplates',
  CALENDAR: '/app/calendar',
  CALENDAR_CALCOM: '/app/calendar/cal-com',
  CALENDAR_CALCOM_BOOKINGS: '/app/calendar/cal-com/manage-bookings',
  CALENDAR_CALCOM_KEY_PICKUPS: '/app/calendar/cal-com/key-pickups',
  AUTH_CONFIRM_EMAIL_CHANGE: '/auth/confirm-email-change',
};

export const ICONS = {
  Admin: 'service-provider',
  Accessibility: 'wheelchair',
  Contract: 'file-contract',
  Dryer: 'dryer',
  Electrical: 'bolt',
  Exteriors: 'door-open',
  Exterior: 'door-open',
  Refrigerator: 'refrigerator',
  Other: 'house-damage',
  OtherDoc: 'file-alt',
  General: 'house-damage',
  Heating: 'temperature-hot',
  'Home Owner': 'home-owner',
  Realtor: 'home-owner',
  Image: 'image',
  Invoice: 'file-invoice-dollar',
  Microwave: 'microwave',
  'Owners Manual': 'tools',
  Plumbing: 'toilet',
  'Property Developer': 'property-manager',
  'Strata Manager': 'property-manager',
  'Service Provider': 'service-provider',
  Spreadsheet: 'file-spreadsheet',
  Ventilation: 'fan',
  Warranty: 'shield-check',
  Washer: 'washer',
  Submitted: 'submitted',
  Scheduled: 'scheduled',
  Assigned: 'assigned',
  Approved: 'approved',
  'En Route': 'en-route',
  'On Hold': 'on-hold',
  'In Progress': 'in-progress',
  Resolved: 'resolved',
  Declined: 'declined',
  Closed: 'closed',
  'Under Review': 'hourglass-end',
  TV: 'tv',
  'Create New': 'plus',
  'Copy From Existing': 'clone',
  Guided: 'handshake',
  'Self-Guided': 'walking',
  Vendor: 'service-provider',
  Video: 'video',
  HVAC: 'air-conditioner',
  Faucet: 'faucet',
  Thermostat: 'sort-circle',
  'Shower / Tub': 'bath',
  Window: 'window-frame',
  'Window Covering': 'blinds',
  Oven: 'oven',
  Furnace: 'fireplace',
  'Washing Machine': 'washer',
  Toilet: 'toilet',
  Doors: 'door-closed',
  Cabinetry: 'cabinet-filing',
  'Extractor Fan': 'fan',
  Tile: 'square',
  'Hood Fan': 'fan',
  Range: 'box-full',
  Mirrors: 'send-backward',
  Paint: 'paint-brush-alt',
  Sink: 'bath',
  'Casing/Millwork': 'digital-tachograph',
  Lighting: 'lightbulb',
  'Flooring - Tile': 'square',
  'Bathroom Accessories': 'toilet ',
  'In-Sink Disposal': 'bath',
  'Flooring - Vinyl': 'record-vinyl',
  'Flooring - Other': 'rectangle-landscape',
  'Flooring - Laminate': 'align-justify',
  Landscaping: 'rectangle-landscape',
  Dishwasher: 'washer',
  'Flooring - Hardwood': 'house',
  'Flooring - Carpet': 'house',
  Countertop: 'house',
  Occupant: 'home-owner',
  'Heating/Cooling': 'air-conditioner',
  Finishing: 'ballot-check',
  'Electrical Outlet': 'bolt',
  'Service Manager': 'service-provider',
};

export const ITEM_WARRANTIES = [1, 2, 3, 5, 10, 0];

export const USER_TYPES = [
  'Property Developer',
  'Strata Manager',
  'Home Owner',
  'Realtor',
  'Service Provider',
  'Vendor',
  'Occupant',
  'Service Manager',
  'Admin',
];

export const DOCUMENT_TYPES = [
  'Warranty',
  'Owners Manual',
  'Image',
  'Invoice',
  'Spreadsheet',
  'Contract',
  'General',
  'Video',
];

export const ISSUE_TYPES = [
  'Accessibility',
  'Electrical',
  'Exteriors',
  'Heating',
  'Plumbing',
  'Ventilation',
  'Other',
];

export const S3BucketConfig = {
  bucketName: `${import.meta.env.VITE_ENVIRONMENT}-juniper-file-store`,
  region: 'ca-central-1',
  url: `https://${import.meta.env.VITE_ENVIRONMENT}-juniper-file-store.s3.ca-central-1.amazonaws.com/`,
};

// juniper key.
export const GOOGLE_API_KEY = import.meta.env.VITE_GOOGLE_API_KEY;

export const PAGINATION_LIMIT = '100';

export const HOTJAR_VERSION = 6;

export const STATUSES = [
  { label: 'Submitted', value: 'Submitted', id: 'submitted' },
  { label: 'Scheduled', value: 'Scheduled', id: 'scheduled' },
  { label: 'En Route', value: 'En Route', id: 'enRoute' },
  { label: 'On Hold', value: 'On Hold', id: 'onHold' },
  { label: 'In Progress', value: 'In Progress', id: 'inProgress' },
  { label: 'Resolved', value: 'Resolved', id: 'resolved' },
  { label: 'Declined', value: 'Declined', id: 'declined' },
  { label: 'Closed', value: 'Closed', id: 'closed' },
  { label: 'Archive', value: 'Archive', id: 'archive' },
  { label: 'Assigned', value: 'Assigned', id: 'assigned' },
  { label: 'Under Review', value: 'Under Review', id: 'underReview' },
  { label: 'Approved', value: 'Approved', id: 'approved' },
  {
    label: 'One Year Warranty',
    value: 'One Year Warranty',
    id: 'oneYearWarranty',
  },
];

export const STATUS_MESSAGES = (branding) => [
  {
    status: 'Submitted',
    message: `You have received a ${branding.text.serviceRequest}.`,
  },
  { status: 'Under Review', message: 'Service Request has been Under Review.' },
  { status: 'Approved', message: 'Service Request has been approved.' },
  { status: 'Assigned', message: 'Service Request has been assigned.' },
  { status: 'Scheduled', message: 'Scheduled for: ' },
  { status: 'En Route', message: 'En Route to: ' },
  { status: 'On Hold', message: 'This Service Request has been put On Hold' },
  { status: 'In Progress', message: 'In Progress at: ' },
  { status: 'Resolved', message: 'Service Request has been Resolved.' },
  { status: 'Declined', message: 'Service Request was Declined.' },
  { status: 'Closed', message: 'Service Request has been Closed.' },
  { status: 'Archive', message: 'Archive' },
  {
    status: 'One Year Warranty',
    message: 'One Year Warranty Service Request.',
  },
];

export const USER_ROLES = {
  SUPER_ADMIN: 'Super Admin',
  ADMIN: 'Admin',
  PROPERTY_DEVELOPER: 'Property Developer',
  STRATA_MANAGER: 'Strata Manager',
  HOME_OWNER: 'Home Owner',
  REALTOR: 'Realtor',
  SERVICE_PROVIDER: 'Service Provider',
  VENDOR: 'Vendor',
  OCCUPANT: 'Occupant',
  SERVICE_MANAGER: 'Service Manager',
};

export const AGORA_VIDEO_CALL_APP_ID = 'f8cc45c1de7c4a1dbc6afa01385ea94e';

export const SuccessMessages = {
  passwordSuccess:
    ' ⓘ You have changed your password. Please sign In with your credentials.',
  propertyAdded: 'ⓘ Property has been added.',
  pdfDownloadNotification:
    'PDF generation is in process and will be downloaded shortly.',
  specificationSaved: 'Specification saved successfully',
  specificationUpdated: 'Specification updated successfully',
  specificationDeleted: 'Specification deleted successfully',
};

export const ErrorMessages = {
  passwordValidation:
    'Your new password and confirm password must be the same.',
  userNotFound: 'User is not found.',
  userAlreadyActivated: 'User already activated.',
  linkHasExpired: 'Link has expired',
  passwordFail: 'Password update fail, please try again.',
  suitesImportError: 'Suites import failed',
  catalogImportError: 'Catalogs import failed',
  error: 'Something went wrong, please try again.',
  csvValidation:
    'The file does not match the template. Please download the template and upload again.',
  noDatacsv: 'There is no data available in your file to upload.',
  areasFetchFailed: 'Rooms fetching failed, please try again.',
  propertyAddError:
    ' 🚫 Something went wrong with adding a property, please try again.',
  passwordRequirement1: 'Must contain between 8 to 20 characters',
  passwordRequirement2:
    'Must contain at least one capital (uppercase) letter (ex: A-Z)',
  passwordRequirement3: 'Must contain at least one lowercase letter (ex: a-z)',
  passwordRequirement4: 'Must contain at least one number (ex: 0-9)',
  passwordRequirement5: `Must contain at least one special character (ex: "!@#$%^&*()`,
  wrongPassword:
    'Your old password has incorrect, please provide the valid password',
  specificationFailed: 'Specification saving failed',
  specificationUpdateFailed: 'Specification updating failed',
  specificationDeleteFailed: 'Specification deleting failed',
  sendEmailFailed: 'Something went wrong while sending an email to receiver',
};

export const SuiteHeaders = [
  { label: 'Number', key: 'Number' },
  { label: 'Status', key: 'Status' },
  { label: 'StrataLot', key: 'StrataLot' },
  { label: 'WarrantyDefaultStartDate', key: 'WarrantyDefaultStartDate' },
  { label: 'Rooms', key: 'Rooms' },
  { label: 'Assets', key: 'Assets' },
  { label: 'WarrantyAddress', key: 'WarrantyAddress' },
  { label: 'Building', key: 'Building' },
  { label: 'Level', key: 'Level' },
  { label: 'ParkingStalls', key: 'ParkingStalls' },
  { label: 'StorageLockers', key: 'StorageLockers' },
  { label: 'WarrantyNumber', key: 'WarrantyNumber' },
];

export const SuiteDummyData = [
  {
    Number: 101,
    Status: 'Sold',
    StrataLot: 1,
    WarrantyDefaultStartDate: '7/16/2025',
    Rooms: 'Balcony',
    Assets:
      'Ceiling #Electrical Outlet #Flooring #Hose Bib #Lighting #Other #Patio Door #Railing #Wall #Window Frames/Glass',
    WarrantyAddress: '1234 1st Street, Vancouver BC V1V 1V1',
    Building: 'Building 1',
    Level: 1,
    ParkingStalls: '123423-EV, 445234,2345345',
    StorageLockers: 'r56644,243434,34rdsa',
    WarrantyNumber: '234234534t5-75',
  },
  {
    Number: 102,
    Status: 'Sold',
    StrataLot: 1,
    WarrantyDefaultStartDate: '7/16/2025',
    Rooms: 'Kitchen',
    Assets:
      'Baseboard #Cabinets #Ceiling Light #Cooktop #Dishwasher #Electrical Outlet #ERV #Fire Sprinkler #Flooring #Gas Shut-Off #Hood Fan #Kitchen Backsplash #Kitchen Faucet #Kitchen Island #Kitchen Sink #Kitchen Storage/Pantry #Microwave #Other #Oven #Refrigerator #Smoke Detector #Undercabinet Lighting #Wall #Water Shut-Off #Window #Window Covering',
    WarrantyAddress: '1234 1st Street, Vancouver BC V1V 1V1',
    Building: 'Building 1',
    Level: 1,
    ParkingStalls: '111111-EV, 22222,44444',
    StorageLockers: 'r1111,28888,34yyy',
    WarrantyNumber: '234234534t5-95',
  },
  {
    Number: 101,
    Status: 'Sold',
    StrataLot: 2,
    WarrantyDefaultStartDate: '7/16/2025',
    Rooms: 'Kitchen',
    Assets:
      'Ceiling #Electrical Outlet #Flooring #Hose Bib #Lighting #Other #Patio Door #Railing #Wall #Window Frames/Glass',
    WarrantyAddress: '1234 1st Street, Vancouver BC V1V 1V1',
    Building: 'Building 2',
    Level: 2,
    ParkingStalls: '123423-EV, 445234,2345345',
    StorageLockers: 'r56644,243434,34rdsa',
    WarrantyNumber: '234234534t5-78',
  },
  {
    Number: 102,
    Status: 'Sold',
    StrataLot: 2,
    WarrantyDefaultStartDate: '7/16/2025',
    Rooms: 'Balcony',
    Assets:
      'Baseboard #Cabinets #Ceiling Light #Cooktop #Dishwasher #Electrical Outlet #ERV #Fire Sprinkler #Flooring #Gas Shut-Off #Hood Fan #Kitchen Backsplash #Kitchen Faucet #Kitchen Island #Kitchen Sink #Kitchen Storage/Pantry #Microwave #Other #Oven #Refrigerator #Smoke Detector #Undercabinet Lighting #Wall #Water Shut-Off #Window #Window Covering',
    WarrantyAddress: '1234 1st Street, Vancouver BC V1V 1V1',
    Building: 'Building 2',
    Level: 2,
    ParkingStalls: '111111-EV, 22222,44444',
    StorageLockers: 'r1111,28888,34yyy',
    WarrantyNumber: '234234534t5-99',
  },
];

export const CatalogHeaders = [
  { label: 'Name', key: 'Name' },
  { label: 'Type', key: 'Type' },
  { label: 'Warranty', key: 'Warranty' },
  { label: 'Make', key: 'Make' },
  { label: 'Model', key: 'Model' },
  { label: 'Properties', key: 'Properties' },
];

export const CatalogDummyData = [
  {
    Name: 'Test',
    Type: 'itemType',
    Warranty: 3,
    Make: 'Make',
    Model: 'itemModel',
    Properties: 'Property1&Property2',
  },
];

export const IntroContent = {
  rooms:
    "Below you'll find an inventory of all of the rooms and items in your home. Click any of these items for detailed information including manuals, maintenance reminders, FAQ and more.",
  serviceRequests:
    'Have a warranty service request? Submit your request here, and view existing requests to check in on their status.',
  manualsAndDocuments:
    'Important documents and operator manuals for the various systems and items in your home are available here, along with other documentation including homeowner manuals, warranty documents and more.',
  maintenanceReminders:
    'Learn about the various activities you should take to keep your home well maintained.',
};

export const repeatTypes = ['Weekly', 'Monthly', 'Annually', 'Custom'];
export const repeatStartHours = 1;
export const repeatEndHours = 30;

export const repeatEveryTypes = ['Day', 'Week', 'Month', 'Year'];

export const webUrlAccess = window.location.origin;
